import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { SaveToProjectApi, SaveToProjectApiImpl } from './src/apis/index';
import { SaveToProjectService, SaveToProjectServiceImpl } from './src/services/index';
import { OpenDialogService, OpenDialogServiceImpl } from './src/services/open-service';
import { I18nService } from '@eureka/shared/core-services/src/i18n-service';
import { i18n } from './src/locales';
export * from './src/apis/index';
export * from './src/services/index';

export const saveToProjectModule = new ContainerModule((bind) => {
  bind(SaveToProjectApi).to(SaveToProjectApiImpl);
  bind(SaveToProjectService).to(SaveToProjectServiceImpl);
  bind(OpenDialogService).to(OpenDialogServiceImpl);
  bind(I18nService).toConstantValue({
    t: i18n.global.t.bind(i18n),
    te: i18n.global.te.bind(i18n),
    locale: i18n.global.locale.value,
  });
});
